import { getAuthorizations } from '@fs/zion-permissions'
import { useEffect, useState } from 'react'
import { isLoggedIn } from '@fs/zion-config'
import useErrorHandlerOverlay from './useErrorHandlerOverlay'

const dashboardPermissions = [
  'RootsTechSpeakerAccessPermission',
  'RootsTechExhibitorAccessPermission',
  'RootsTechSponsorAccessPermission',
  'RootsTechHomelandAccessPermission',
  'RootsTechContentAdminAccessPermission',
  'RootsTechSuperAdminAccessPermission',
]

// Returns an object with boolean values for each permission indicating whether the user has access or not
export default function usePermissionsAccess() {
  const [permissions, setPermissions] = useState(
    dashboardPermissions.reduce((acc, permission) => {
      acc[permission] = false
      return acc
    }, {})
  )
  const [error, setError] = useState()
  useErrorHandlerOverlay(error)

  useEffect(() => {
    if (!isLoggedIn) {
      return null
    }

    let isCurrent = true
    getAuthorizations({ context: 'RootsTech', permissions: dashboardPermissions })
      .then((results) => {
        const authorizedPermissions = results[0]?.authorizedPermissions || []
        const newPermissions = dashboardPermissions.reduce((acc, permission) => {
          acc[permission.replace('RootsTech', 'has').replace('Permission', '')] =
            authorizedPermissions.includes(permission) || false
          return acc
        }, {})
        isCurrent && setPermissions(newPermissions)
      })
      .catch((e) => {
        isCurrent && setError(e)
      })
    return () => {
      isCurrent = false
    }
  }, [])

  return permissions
}
